export class HospitalPrivilegeDetail {
    id: number;
    name: string;
    departmentName: string;
    city: string;
    state: string;
}
